export default __webpack_public_path__ + "static/impact-d18a84ad18b4856d76e77c886e13db5e.png";